import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoBarGroup(props) {

  const options = {
    title: {
      text: props.title,
      align: 'center',
      style: {
        fontSize: "18px",
        fontWeight: "bold",
        fontFamily: undefined,
        color: "#263238",
      },
    },

    chart: {
      type: 'bar',
      height: 500,
      stacked: false,
    },
    series: props.series,
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '80%', // Aumenta el grosor de las barras (puedes usar '90%', '100%', etc.)
        borderRadius: 5,
        borderRadiusApplication: 'end'
      }
    },

    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: props.categories,
      labels: {
        style: {
          fontSize: '12px'
        }
      }
    },
    legend: {
      position: 'right',
      offsetY: 40
    },
    colors: ['#f97316', '#3b82f6'], // USD naranja, PEN azul
    tooltip: {
      y: {
        formatter: val => `${val.toFixed(2)}`
      }
    }
  };
  return (
    <div id="chart">
      <Chart options={options} series={options.series} type="bar" height={350} />
    </div>
  );
}